import React from 'react';
import PropTypes, { any } from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

import styles from '../search.scss';

const ConferenceFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const conferences = searchTypes?.conferences ? searchTypes.conferences : [];

    const selectedConferenceValue = filters?.conference && conferences?.find(v => v.value === filters.conference);
    const collegeCornerFilterValue = selectedConferenceValue?.description ? selectedConferenceValue.description : 'All conferences';
    const filterName = 'conference';
    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={handleFilterClick}
                searchFor={type}
                isActive={(filters?.conference) || filterModal === filterName}
                onClick={() => handleFilterClick(filterName)}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >

                {type === 'collegeCorner' ? collegeCornerFilterValue : 'Conference'}
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Conference'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <DropdownFilter
                            options={conferences}
                            selected={filterInputs.conference}
                            placeholder={'Any Conference'}
                            onChange={(conference) => {
                                handleFilterUpdate({ conference });
                            }}
                            data-testid={dataTestId && `${dataTestId}.dropdown`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

ConferenceFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    searchTypes: PropTypes.objectOf(any),
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

ConferenceFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    searchTypes: {},
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default ConferenceFilter;
